<template>
  <TenderStep
    :current-step="currentStep"
    :total-steps="totalSteps"
    :error-transition="false"
  >
    <template slot="header">
      <div class="question-big">
        {{ $t("requestTender.profession.question") }}
      </div>
      <span class="text-base font-normal text-[#4a4a4a]">{{
        $t("requestTender.profession.subtitle")
      }}</span>
    </template>

    <section>
      <div class="relative">
        <AutocompleteProfession
          ref="professionAutocomplete"
          v-model="newTender.profession.value"
          :placeholder="$t('requestTender.profession.placeholder')"
          :show-error-msg="false"
          :validation-state="professionValidation"
          autofocus
          hide-down-icon
          @select="onSelect"
          @blur="professionValidation.$touch()"
          @keyup.enter.exact.native="emitNext('enter')"
        >
          <template #empty>
            {{ $t("requestTender.profession.notFound") }}
          </template>
        </AutocompleteProfession>
        <span
          v-if="!professionValidation.$invalid"
          class="absolute right-3 top-1/2 -translate-y-1/2 text-positive pointer-events-none"
        >
          <IconComponent class="fa-lg" icon="check" />
        </span>
      </div>
    </section>

    <template slot="error">
      <div v-if="professionValidation.$error">
        {{ professionValidation.$errors[0]?.$message }}
      </div>
    </template>

    <template slot="footer">
      <WizardNextButton
        :disabled="professionValidation.$invalid"
        @click="emitNext()"
      />
    </template>
  </TenderStep>
</template>

<script>
import { toRefs } from "@nuxtjs/composition-api";
import WizardNextButton from "./WizardNextButton.vue";
import TenderStep from "@/components/TenderStep";
import AutocompleteProfession from "~/components/_refactored/autocomplete/AutocompleteProfession.vue";
import { useNewTender } from "~/composables/tender/useNewTender";
import { useTrackWizardClick } from "~/composables/tracking/useTrackWizardClick";
import { useTrackProfessionViewContent } from "~/composables/tracking/useTrackProfessionViewContent";

export default {
  name: "ProfessionStepModule",
  components: { TenderStep, AutocompleteProfession, WizardNextButton },
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    moduleSlug: { type: String, default: "profession" },
  },
  emits: ["next", "profession-selected"],
  setup(props) {
    const { trackNextAttempt } = useTrackWizardClick(toRefs(props));
    const { trackProfessionViewContent } = useTrackProfessionViewContent();
    return {
      trackNextAttempt,
      newTender: useNewTender(),
      trackProfessionViewContent,
    };
  },
  computed: {
    // The autocomplete's v-model is the profession OBJECT, so the global
    // `required` rule fully replaces the old vee-validate `professionOf`
    // name-list matching (and its hidden-input helper).
    professionValidation() {
      return this.newTender.v$.value.profession;
    },
  },
  methods: {
    onSelect(profession) {
      if (!profession) return;
      this.$emit("profession-selected", profession);
      this.trackProfessionViewContent(profession);
    },
    emitNext(trigger = "click") {
      this.trackNextAttempt({
        trigger,
        disabled: this.professionValidation.$invalid,
      });
      if (this.professionValidation.$invalid) {
        this.professionValidation.$touch();
        return;
      }
      this.newTender.saveToStorage();
      this.$emit("next", { field: "profession" });
    },
  },
};
</script>
